// import AdminDashboard from './AdminDashboard';
// import StaffDashboard from "./StaffDashboard";

// export default function DashboardPage() {

//   const userStr = localStorage.getItem("user");

//   if (!userStr) return null
//   const user = JSON.parse(userStr);


//   const isAdmin = (
//     user.role === "admin" ||
//     user.role === "superAdmin"
//   );

//   return isAdmin
//     ? <AdminDashboard />
//     : <StaffDashboard />;
// }




import {
  FaArrowLeft,
  FaArrowRight,
  FaChartLine,
  FaClipboardList,
  FaUsers,
} from "react-icons/fa";
import Logo from "../../assets/logo.png";

export default function Dashboard() {
  return (
    <div className="flex min-h-full items-center justify-center overflow-hidden bg-slate-50 px-6">
      <div className="relative w-full max-w-4xl text-center">
        {/* Decorative background */}
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-80 w-80 -translate-x-1/2 -translate-y-1/2 rounded-full border border-slate-200" />

        <div className="pointer-events-none absolute left-1/2 top-1/2 h-60 w-60 -translate-x-1/2 -translate-y-1/2 rounded-full border border-slate-200" />

        {/* Floating icons */}
        <div className="absolute left-[12%] top-[15%] hidden animate-[float_4s_ease-in-out_infinite] sm:flex">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-white shadow-sm">
            {FaUsers({
              className: "text-lg text-slate-400",
            })}
          </div>
        </div>

        <div className="absolute right-[12%] top-[22%] hidden animate-[float_5s_ease-in-out_infinite_0.5s] sm:flex">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-white shadow-sm">
            {FaChartLine({
              className: "text-lg text-slate-400",
            })}
          </div>
        </div>

        <div className="absolute bottom-[18%] left-[18%] hidden animate-[float_5s_ease-in-out_infinite_1s] sm:flex">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-white shadow-sm">
            {FaClipboardList({
              className: "text-lg text-slate-400",
            })}
          </div>
        </div>

        <div className="absolute bottom-[15%] right-[18%] hidden animate-[float_4s_ease-in-out_infinite_1.5s] sm:flex">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-white shadow-sm">
            {FaUsers({
              className: "text-lg text-slate-400",
            })}
          </div>
        </div>

        {/* Main logo */}
        <div className="relative mx-auto mb-8 flex h-44 w-44 items-center justify-center">
          <div className="absolute inset-0 animate-ping rounded-full bg-blue-50 opacity-40" />

          <div className="relative flex h-36 w-36 items-center justify-center rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/50">
            <img
              src={Logo}
              alt="Chrome Architecture"
              className="h-24 w-24 object-contain"
            />
          </div>
        </div>

        {/* Welcome text */}
        <div className="relative">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">
            Chrome Architecture
          </p>

          <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Welcome to your workspace
          </h1>

          <p className="mx-auto mt-4 max-w-lg text-sm leading-6 text-slate-500 sm:text-base">
            Everything you need to manage your organization is just a click
            away.
          </p>

          {/* Sidebar hint */}
          <div className="mt-8 inline-flex items-center gap-3 rounded-full border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-500 shadow-sm">
            {FaArrowLeft({
              className: "text-xs text-slate-400",
            })}

            <span>Explore the options in the sidebar</span>

            {FaArrowRight({
              className: "text-xs text-blue-500",
            })}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-12px);
          }
        }
      `}</style>
    </div>
  );
}